var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Google Calendar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2578 15.6909L20.0138 16.7709L21.2018 15.9069V22.1709H22.4978V13.9629H21.4178L19.2578 15.6909Z",
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2073 17.8088C17.676 17.3783 17.967 16.7813 17.967 16.1221C17.967 14.8118 16.8172 13.7461 15.4042 13.7461C14.2027 13.7461 13.1752 14.5028 12.9067 15.5858L14.1495 15.9016C14.2732 15.4036 14.8005 15.0421 15.4042 15.0421C16.1107 15.0421 16.686 15.5266 16.686 16.1221C16.686 16.7176 16.1107 17.2021 15.4042 17.2021H14.6565V18.4981H15.4042C16.215 18.4981 16.899 19.0613 16.899 19.7281C16.899 20.4061 16.2495 20.9581 15.4507 20.9581C14.7292 20.9581 14.1128 20.5006 14.0153 19.8946L12.75 20.1016C12.9465 21.3286 14.1075 22.2541 15.45 22.2541C16.9552 22.2541 18.18 21.1208 18.18 19.7281C18.18 18.9608 17.802 18.2723 17.2073 17.8088Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 31.5H10.5L9.75 28.5L10.5 25.5H25.5L26.25 28.5L25.5 31.5Z",
    fill: "#FBC02D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 26.25L31.5 25.5V10.5L28.5 9.75L25.5 10.5V25.5L28.5 26.25Z",
    fill: "#4CAF50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 10.5L26.25 7.5L25.5 4.5H6.75C5.50725 4.5 4.5 5.50725 4.5 6.75V25.5L7.5 26.25L10.5 25.5V10.5H25.5Z",
    fill: "#1E88E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25.5V31.5L31.5 25.5H25.5Z",
    fill: "#E53935"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 4.5H25.5V10.5H31.5V6.75C31.5 5.50725 30.4928 4.5 29.25 4.5Z",
    fill: "#1565C0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 31.5H10.5V25.5H4.5V29.25C4.5 30.4928 5.50725 31.5 6.75 31.5Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.b6c3f61ed14ad395bafc13dce85e871d.svg";
export { ForwardRef as ReactComponent };